import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-privacy-policy',
    imports: [],
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  revisionDate = 'May 2026';

  constructor() { }

  ngOnInit(): void {
  }

}